<script setup lang="ts">
import Separator from "@/dsComponents/Separator.vue";

interface FormSectionProps {
    separator?: boolean;
    title?: string;
    subtitle?: string | boolean;
    size?: "lg" | "md" | "sm";
}

withDefaults(defineProps<FormSectionProps>(), {
    size: "lg",
});
</script>

<template>
    <div :class="['ds-form-section', size, { paddingTop: separator }]">
        <Separator v-if="separator" />
        <div class="form-section-content">
            <div class="title-subtitle">
                <slot name="title">
                    <h2 v-if="title" class="section-title">{{ title }}</h2>
                </slot>
                <p v-if="subtitle" class="section-subtitle">{{ subtitle }}</p>
            </div>
            <div class="action">
                <slot />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.ds-form-section {
    color: $text-main-900;
    align-content: center;
    &.paddingTop {
        padding-top: 12px;
    }

    .form-section-content {
        display: flex;
        justify-content: space-between;
        gap: 6px;

        .title-subtitle {
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 6px;

            .section-title {
                @include font-size-20;
                font-weight: 600;
            }
            .section-subtitle {
                @include font-size-16;
                font-weight: 400;
                color: $text-sub-600;
            }
        }
    }

    & :deep(.ds-separator) {
        margin-bottom: 24px;
    }

    &.md {
        min-height: 36px;
        .form-section-content {
            .section-title {
                @include font-size-18;
            }
            .section-subtitle {
                @include font-size-14;
            }
        }
    }
    &.sm {
        .form-section-content {
            .section-title {
                @include font-size-16;
            }
            .section-subtitle {
                @include font-size-14;
            }
        }
    }
}
</style>
